import {Component, OnInit, ViewChild} from '@angular/core';
import {WfTableComponent} from '../../../common/table-sort/wf-table.component';
import {BatchService} from '../../../services/batch.service';
import {GenericModalService} from '../../../services/generic-modal.service';
import {BatchTemplateModalComponent} from './batch-template-modal/batch-template-modal.component';

@Component({
  selector: 'app-template-configuration',
  templateUrl: './template-configuration.component.html',
  styleUrls: ['./template-configuration.component.css']
})
export class TemplateConfigurationComponent implements OnInit {

  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;
  templateList: any[];
  pleaseWait = true;
  successMessage = '';
  errorMessage = '';
  modalComponent: any = BatchTemplateModalComponent;

  constructor(private batchService: BatchService, private modalService: GenericModalService) { }

  ngOnInit() {
    this.loadList();
  }

  loadList() {
    this.batchService.getAllBatchTemplates()
      .subscribe(res => {
        this.pleaseWait = false;
        setTimeout(() => this.templateList = res, 1);
    }, error1 => this.errorMessage = error1);
  }

  onDeleteBatch(template) {
    this.errorMessage = '';
    let alert: any;
    alert = this.modalService.showConfirmModal('Aviso de exclusão', `Confirma a exclusão do layout <b>${template.name}</b>?`);
    alert.then( resp => {
      if (resp.value) {
        this.batchService.deleteBatchTemplate(template.batchTemplateId)
          .subscribe( () => {
              this.successMessage = `Layout ${template.name} excluído com sucesso.`;
              this.ngOnInit();
              setTimeout(() => {
                this.successMessage = '';
              }, 2000);
            },
            error1 => {
              this.errorMessage = error1;
            });
      }
    });
  }

  onAddNew() {
    const newLayout = {};
    const result$ = this.modalService.showObjModal(this.modalComponent, 'Cadastrar Layout', newLayout);
    if (result$) {
      result$.asObservable()
        .subscribe(
          itemHasBeenSaved => {
            if (itemHasBeenSaved) { this.ngOnInit(); }
          });
    }
  }

  onEditLayout(layout: any) {
    const result$ = this.modalService.showObjModal(this.modalComponent, 'Editar Layout', layout);
    if (result$) {
      result$.asObservable()
        .subscribe(
          itemHasBeenSaved => {
            if (itemHasBeenSaved) { this.ngOnInit(); }
          }
        );
    }
  }

}
